// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3936":"cfc53c3433779a11","5261":"de10667c4c676f28","8457":"538a9ba2c0fc4e96"}[chunkId] + ".js";
};